import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@components-clean/core/button';
import { Popup } from '@components-clean/core/popup/popup';
import { StudyDataFilter } from '@components-clean/core/study-data-filter';
import { FilterCategory } from '@components-clean/core/study-data-filter/study-data-filter.interfaces';
import { useStudyDataFilterContext } from '@contexts-clean/study-data-filter-context';
import { CategoryConfig, CM2Dataset } from '@interfaces/central-monitoring';
import styles from '@pages-clean/dummy-page/pages/data-view-config-poc/styles.module.scss';
import { MapConfigToFilterCategories } from '@utils-clean/study-data-filter/study-data-filter.service';
import { useTranslation } from '@hooks/index';
import { useGetFilterUIConfig } from '@apis/bff-api/central-monitoring';

type FilterButtonProps = {
    studyId: string;
    dataset: CM2Dataset;
    dataViewConfigId: string;
};

export const FilterButton = ({ studyId, dataset, dataViewConfigId }: FilterButtonProps) => {
    const { setSessionId } = useStudyDataFilterContext();

    const anchor = useRef<HTMLDivElement | null>(null);

    const [show, setShow] = useState(false);
    const [categories, setCategories] = useState<Array<FilterCategory>>([]);
    const [configUI, setConfigUI] = useState<Array<CategoryConfig>>([]);
    const { t } = useTranslation();
    const { data, isMutating } = useGetFilterUIConfig(studyId, dataViewConfigId, false);

    useEffect(() => {
        if (data) {
            setConfigUI(data.categoryConfig);
            setSessionId(data.sessionId);
        }
    }, [data]);

    useEffect(() => {
        setCategories(MapConfigToFilterCategories(configUI));
    }, [configUI]);

    const onClick = () => {
        setShow(!show);
    };

    const onApply = () => {
        setShow(false);
    };

    return (
        <>
            <div ref={anchor}>
                <Button
                    data-testid="filter-btn"
                    alternativeStyle
                    primary
                    disabled={isMutating}
                    onClick={onClick}
                    className={styles.filterBtn}
                >
                    <FontAwesomeIcon icon={['far', 'filter']} /> {t('filters')}
                </Button>
            </div>

            {!isMutating && data && dataset.id && (
                <Popup
                    data-testid="study-filter-popup"
                    anchor={anchor?.current}
                    show={show}
                    border="topBorder"
                    alternativeStyle
                    closeOnBlur={false}
                    popupCard
                >
                    <StudyDataFilter
                        data-testid="study-filter-id"
                        categories={categories}
                        onApply={onApply}
                        datasetId={dataset.id}
                        studyRef={studyId}
                        onClose={() => setShow(false)}
                        dataViewRef={dataViewConfigId}
                    />
                </Popup>
            )}
        </>
    );
};
